import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=05a3b133&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=05a3b133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3b133",
  null
  
)

export default component.exports